var messages = {
  confirm: '确认',
  noOptions: '暂无选项',
  noResults: '暂无搜索结果',
  selectAll: '全选',
  placeholder: '请选择',
  dunhao: '、',
  searchPlaceHolder: '搜索',
  reset: '重置',
  atLeast: '至少选择${n}个',
  addNew: '点击新建'
};
export default messages;